import { Component, ElementRef, ViewChild, Input, OnChanges, EventEmitter, Output } from '@angular/core';
import { environment } from 'src/environment.prod';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ScChatbotTriggerButtonComponent } from '../trigger-button/trigger-button.component';


@Component({
    selector: 'sc-chatbot-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.scss'],
    standalone: false
})
export class ScChatbotOverlayComponent implements OnChanges {

  constructor() { }

  @ViewChild("chatbotOverlay", { static: true })
  chatbotOverlay: ElementRef;

  @ViewChild(ScChatbotTriggerButtonComponent, { static: true })
  public trigger: ScChatbotTriggerButtonComponent;

  @Input()
  chat = null;

  hasUserMessage = false;

  chatbotOverlayOpenedOnce = false;

  private requestShowDestroy = new Subject<any>();

  isActive = false;

  isRestartConfirmVisible = false;

  @Input()
  requestShow: Observable<any>;

  @Input()
  showRestart = false;

  @Output()
  chatEnded = new EventEmitter<any>();

  @Output()
  restart = new EventEmitter<any>();


  ngOnChanges(changes: any) {
    if (changes.chat) this.hasUserMessage = false;

    if (changes.requestShow) {
      this.requestShowDestroy.next();
      if (!this.requestShow) return;

      this.requestShow.pipe(takeUntil(this.requestShowDestroy)).subscribe((chat: any) => {
        if (chat !== this.chat) this.hasUserMessage = false;
        this.chat = chat;
        this.show();
      });
    }
  }

  toggle() {

    if (this.isActive) 
    {
      this.hide();
    }
    else
    {
      this.show();
    }
  }  

  show() {
    this.trigger.stopPulse();
    this.trigger.state = 'close';

    let chatbotOverlay = this.chatbotOverlay.nativeElement; 
    chatbotOverlay.classList.add('is-active');
    this.chatbotOverlayOpenedOnce = true;
    this.isActive = true;
  }

  hide() {
    let chatbotOverlay = this.chatbotOverlay.nativeElement;
    this.trigger.state = 'chat';
    this.trigger.badge = 0;
    chatbotOverlay.classList.remove('is-active');
    this.isActive = false;
    this.isRestartConfirmVisible = false;
  }

  confirmRestart() {
    this.isRestartConfirmVisible = false;
    this.restart.emit(this.chat);
  }

  handleEndOfChat() {
    this.chatEnded.emit(this.chat);
  }
}
